import { createMongoAbility } from '@casl/ability';
import { createContextualCan, useAbility as useCASLAbility } from '@casl/react';
import { createContext } from 'react';
import { Actions, Subjects } from 'types/subjects';

const initialAbility = createMongoAbility<[Actions, Subjects]>();

export const AbilityContext = createContext(initialAbility);
export const Can = createContextualCan(AbilityContext.Consumer);
export const useAbility = () => useCASLAbility(AbilityContext);
